import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg24LabelFilter = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsx("filter", {
        id: "24-label-filter_svg__a",
        children: /*#__PURE__*/jsx("feColorMatrix", {
          "in": "SourceGraphic",
          values: "0 0 0 0 0.682353 0 0 0 0 0.721569 0 0 0 0 0.741176 0 0 0 1.000000 0"
        })
      }), /*#__PURE__*/jsx("path", {
        id: "24-label-filter_svg__b",
        d: "M0 .001h15.363v16.103H0z"
      })]
    }), /*#__PURE__*/jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      filter: "url(#24-label-filter_svg__a)",
      children: /*#__PURE__*/jsxs("g", {
        transform: "translate(4 4.5)",
        children: [/*#__PURE__*/jsx("mask", {
          id: "24-label-filter_svg__c",
          fill: "#fff",
          children: /*#__PURE__*/jsx("use", {
            xlinkHref: "#24-label-filter_svg__b"
          })
        }), /*#__PURE__*/jsx("path", {
          fill: "#231916",
          d: "M2.142 1.5 6.57 8.224c.08.122.123.266.123.412v5.539l1.977-.925V8.635c0-.146.043-.29.124-.412L13.221 1.5zm3.801 14.604a.748.748 0 0 1-.75-.75V8.861L.123 1.163C-.027.932-.04.637.09.394S.474 0 .75 0h13.863c.276 0 .53.152.66.395a.75.75 0 0 1-.033.768L10.17 8.86v4.867a.75.75 0 0 1-.432.679l-3.477 1.628a.75.75 0 0 1-.318.07",
          mask: "url(#24-label-filter_svg__c)"
        })]
      })
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24LabelFilter$1 = Svg24LabelFilter;

export { Svg24LabelFilter$1 as default };
